var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnClearCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#B6B8D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_18419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.467 5.3322L11.668 4.5332L8.50036 7.70087L5.33269 4.5332L4.53369 5.3322L7.70136 8.49987L4.53369 11.6675L5.33269 12.4665L8.50036 9.29887L11.668 12.4665L12.467 11.6675L9.29936 8.49987L12.467 5.3322Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_18419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6,
    height: 13.6,
    fill: "white",
    transform: "translate(1.7002 1.7002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClearCircle);
export default __webpack_public_path__ + "static/media/icn-clear-circle.7b7707f371a7a207d0254a4402a8164b.svg";
export { ForwardRef as ReactComponent };